export default __webpack_public_path__ + "static/media/HRA_Contraceptive_Options_Leaflet.6cb9dc25.pdf";